/** Turn `CUSTOMER_REQUESTED_CANCEL` into "Customer Requested Cancel" for void reason display. */
export function formatOrderVoidReasonCode(code: string | null | undefined): string {
  if (code == null || String(code).trim() === "") return "—";
  return String(code)
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function formatVoidedAt(epochMs: number | null | undefined): string {
  if (epochMs == null || Number.isNaN(Number(epochMs))) return "—";
  try {
    return new Date(Number(epochMs)).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return "—";
  }
}
